"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _mobx = require("mobx");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _date_decorator = _interopRequireDefault(require("./date_decorator"));
var _root_model = _interopRequireDefault(require("./root_model"));
var _site = _interopRequireDefault(require("./site"));
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var WorksheetBasic = (_dec = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return (0, _utils.isPresent)(item) ? new _date_decorator["default"](item) : null;
})), _dec2 = (0, _serializr.serializable)((0, _serializr.object)(_site["default"])), _class = /*#__PURE__*/function (_RootModel) {
  function WorksheetBasic() {
    var _this;
    _classCallCheck(this, WorksheetBasic);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WorksheetBasic, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "name", _descriptor2, _this);
    _initializerDefineProperty(_this, "published", _descriptor3, _this);
    _initializerDefineProperty(_this, "youtubeUrl", _descriptor4, _this);
    _initializerDefineProperty(_this, "url", _descriptor5, _this);
    _initializerDefineProperty(_this, "worksheetId", _descriptor6, _this);
    _initializerDefineProperty(_this, "groupId", _descriptor7, _this);
    _initializerDefineProperty(_this, "exerciseEntriesCount", _descriptor8, _this);
    _initializerDefineProperty(_this, "userWorksheetsCount", _descriptor9, _this);
    _initializerDefineProperty(_this, "correctAnswersCount", _descriptor10, _this);
    _initializerDefineProperty(_this, "usersStartedCount", _descriptor11, _this);
    _initializerDefineProperty(_this, "usersFinishedCount", _descriptor12, _this);
    _initializerDefineProperty(_this, "accessWithoutMembership", _descriptor13, _this);
    _initializerDefineProperty(_this, "publishedAt", _descriptor14, _this);
    _initializerDefineProperty(_this, "site", _descriptor15, _this);
    return _this;
  }
  _inherits(WorksheetBasic, _RootModel);
  return _createClass(WorksheetBasic, [{
    key: "publishedAtDate",
    get: function get() {
      return this.publishedAt ? this.publishedAt.formattedDateWithYear : null;
    }
  }, {
    key: "formattedYoutubeUrl",
    get: function get() {
      if ((0, _utils.isPresent)(this.youtubeUrl) && this.youtubeUrl.match('watch')) {
        var regexp = /watch\?v=(...........)/g;
        var match = regexp.exec(this.youtubeUrl);
        if (match) {
          return "https://www.youtube.com/embed/".concat(match[1]);
        }
      } else {
        return this.youtubeUrl;
      }
      return null;
    }
  }, {
    key: "youtubeVideoId",
    get: function get() {
      // also in worksheet.js
      if ((0, _utils.isPresent)(this.youtubeUrl) && this.youtubeUrl.match('watch')) {
        var regexp = /watch\?v=(...........)/g;
        var match = regexp.exec(this.youtubeUrl);
        if (match) {
          return match[1];
        }
      }
    }
  }, {
    key: "imageUrl",
    get: function get() {
      // also in worksheet.js
      if ((0, _utils.isPresent)(this.image)) {
        return this.image.url;
      }
      if (!this.hideYoutubeThumbnail && (0, _utils.isPresent)(this.youtubeThumbnailUrl)) {
        return this.youtubeThumbnailUrl;
      }
    }
  }, {
    key: "youtubeThumbnailUrl",
    get: function get() {
      // also in worksheet.js
      if ((0, _utils.isPresent)(this.youtubeVideoId) && !this.hideYoutubeThumbnail) {
        return "http://img.youtube.com/vi/".concat(this.youtubeVideoId, "/maxresdefault.jpg");
      }
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "name", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "published", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "youtubeUrl", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "url", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "worksheetId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "groupId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "exerciseEntriesCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "userWorksheetsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "correctAnswersCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "usersStartedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "usersFinishedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "accessWithoutMembership", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "publishedAt", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "site", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "publishedAtDate", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "publishedAtDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formattedYoutubeUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "formattedYoutubeUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "youtubeVideoId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "youtubeVideoId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "imageUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "imageUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "youtubeThumbnailUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "youtubeThumbnailUrl"), _class.prototype), _class);
var _default = exports["default"] = WorksheetBasic;